export default __webpack_public_path__ + "static/media/photoBooth11Gif.c41c2332.jpeg";